// Super Admin → Site (HQ Site) — the data-testid registry.
//
// The frontend lane renders these; the jest suites and browser journeys read them.
// Parameterised ids are functions of the row id / content key so the two sides cannot
// disagree on a separator. Contract: docs/hq-site-module/hq-site-api-contract.md.

export const HQ_SITE = Object.freeze({
  page: "hq-site",
  tab: (id) => `site-tab-${id}`, // "content" | "media" | "links"
  loadError: "hq-site-load-error",
  loadRetry: "hq-site-load-retry",

  // Content tab
  sectionNav: (sectionId) => `site-section-${sectionId}`,
  sectionPanel: (sectionId) => `site-section-panel-${sectionId}`,
  field: (key) => `site-field-${key}`,
  fieldInput: (key, locale) => `site-field-${key}-${locale}`,
  fieldVar: (key, name) => `site-field-var-${key}-${name}`,
  fieldOverridden: (key) => `site-field-overridden-${key}`,
  fieldError: (key) => `site-field-error-${key}`,
  fieldSave: (key) => `site-field-save-${key}`,
  fieldReset: (key) => `site-field-reset-${key}`,
  fieldImage: (key) => `site-field-image-${key}`,

  // Media tab
  mediaUpload: "site-media-upload",
  mediaUploadError: "site-media-upload-error",
  mediaEmpty: "site-media-empty",
  mediaCard: (mediaId) => `site-media-${mediaId}`,
  mediaAlt: (mediaId, locale) => `site-media-alt-${mediaId}-${locale}`,
  mediaAltSave: (mediaId) => `site-media-alt-save-${mediaId}`,
  mediaUsage: (mediaId) => `site-media-usage-${mediaId}`,
  mediaReferences: (mediaId) => `site-media-references-${mediaId}`,
  mediaDelete: (mediaId) => `site-media-delete-${mediaId}`,
  mediaError: (mediaId) => `site-media-error-${mediaId}`,

  // Links tab
  linkBucket: (location, group) => (location === "header" ? "site-links-header" : `site-links-footer-${group}`),
  linkAdd: (location, group) => (location === "header" ? "site-link-add-header" : `site-link-add-footer-${group}`),
  linkRow: (linkId) => `site-link-${linkId}`,
  linkUp: (linkId) => `site-link-up-${linkId}`,
  linkDown: (linkId) => `site-link-down-${linkId}`,
  linkEdit: (linkId) => `site-link-edit-${linkId}`,
  linkDelete: (linkId) => `site-link-delete-${linkId}`,
  linkForm: "site-link-form",
  linkLabel: (locale) => `site-link-label-${locale}`,
  linkHref: "site-link-href",
  linkHrefHint: "site-link-href-hint",
  linkNewTab: "site-link-new-tab",
  linkLocation: "site-link-location",
  linkGroup: "site-link-group",
  linkSubmit: "site-link-submit",
  linkCancel: "site-link-cancel",
  linkFormError: "site-link-form-error",

  // Media picker (shared by the content tab, HQ blog, plans and boosters)
  picker: "platform-media-picker",
  pickerClose: "platform-media-picker-close",
  pickerItem: (mediaId) => `platform-media-pick-${mediaId}`,
  pickerEmpty: "platform-media-picker-empty",
  pickerUpload: "platform-media-picker-upload",
  pickerField: (base) => base,
  pickerFieldPreview: (base) => `${base}-preview`,
  pickerFieldChoose: (base) => `${base}-choose`,
  pickerFieldClear: (base) => `${base}-clear`,
});
